<span>
  <a [routerLink]="[routeLink, data.MDM_ID]">{{ data.NAME }}</a>
</span>
